import Form from 'components/Form/Form'
import cls from './FormPage.module.css'

const FormPage = () => {
  return (
    <div className={cls.formPage}>
      <Form/>
    </div>
  )
}

export default FormPage